/* ============================================
   Vision Store — Custom JavaScript
   Handles: mobile menu, cart drawer, search,
   FAQ accordion, testimonials slider, stats counter
   ============================================ */
(function() {
  'use strict';

  function vsFormatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }
    return (cents / 100).toFixed(2) + ' SR';
  }

  function vsEscapeText(value) {
    return String(value || '').replace(/[&<>"']/g, function(char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }[char];
    });
  }

  function showCartAddedToast() {
    var toast = document.querySelector('.vs-cart-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'vs-cart-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.innerHTML = '<span class="vs-cart-toast__check">✓</span><span>تم الإضافة للسلة</span>';
      document.body.appendChild(toast);
    }

    window.clearTimeout(showCartAddedToast.timer);
    toast.classList.add('vs-open');
    showCartAddedToast.timer = window.setTimeout(function() {
      toast.classList.remove('vs-open');
    }, 2200);
  }

  function updateCartCountOnly() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        document.querySelectorAll('.vs-header__cart-count').forEach(function(countEl) {
          countEl.textContent = cart.item_count || 0;
        });
      })
      .catch(function() {});
  }

  /* ---- Mobile Menu Toggle ---- */
  function initMobileMenu() {
    var toggle = document.querySelector('.vs-header__mobile-toggle');
    var drawer = document.querySelector('.vs-mobile-drawer');
    var overlay = document.querySelector('.vs-overlay');
    if (!toggle || !drawer) return;
    if (toggle.getAttribute('data-vs-mobile-bound') === 'true') return;
    toggle.setAttribute('data-vs-mobile-bound', 'true');

    function openMenu() {
      drawer.classList.add('vs-open');
      if (overlay) overlay.classList.add('vs-open');
      document.body.style.overflow = 'hidden';
    }
    function closeMenu() {
      drawer.classList.remove('vs-open');
      if (overlay) overlay.classList.remove('vs-open');
      document.body.style.overflow = '';
    }
    toggle.addEventListener('click', openMenu);
    var closeBtn = drawer.querySelector('.vs-mobile-drawer__close');
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);
    if (overlay) overlay.addEventListener('click', closeMenu);

    // Sub-menu toggles
    var subToggles = drawer.querySelectorAll('[data-vs-sub-toggle]');
    subToggles.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var sub = btn.nextElementSibling;
        if (sub && sub.classList.contains('vs-mobile-drawer__sub')) {
          sub.classList.toggle('vs-open');
        }
      });
    });
  }

  /* ---- Search Dropdown ---- */
  function initSearch() {
    var searchBtn = document.querySelector('[data-vs-search-toggle]');
    var searchDropdown = document.querySelector('.vs-search-dropdown');
    if (!searchBtn || !searchDropdown) return;
    if (searchBtn.getAttribute('data-vs-search-bound') === 'true') return;
    searchBtn.setAttribute('data-vs-search-bound', 'true');
    searchBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      searchDropdown.classList.toggle('vs-open');
      var input = searchDropdown.querySelector('.vs-search-input');
      if (input && searchDropdown.classList.contains('vs-open')) {
        setTimeout(function() { input.focus(); }, 100);
      }
    });
    document.addEventListener('click', function(e) {
      if (!searchDropdown.contains(e.target) && e.target !== searchBtn) {
        searchDropdown.classList.remove('vs-open');
      }
    });
  }

  /* ---- Live Product Search Suggestions ---- */
  function initLiveSearchSuggestions() {
    document.querySelectorAll('[data-vs-live-search]').forEach(function(form) {
      if (form.getAttribute('data-vs-live-search-bound') === 'true') return;
      form.setAttribute('data-vs-live-search-bound', 'true');

      var input = form.querySelector('[data-vs-live-search-input]');
      var panel = form.querySelector('[data-vs-search-suggestions]');
      if (!input || !panel) return;

      var timer = null;
      var controller = null;
      var indexScript = document.querySelector('[data-vs-product-search-index]');
      var localProducts = [];

      if (indexScript) {
        try {
          localProducts = JSON.parse(indexScript.textContent || '[]');
        } catch (error) {
          localProducts = [];
        }
      }

      function getProductImage(product) {
        if (product.featured_image && product.featured_image.url) return product.featured_image.url;
        if (product.image) return product.image;
        return '';
      }

      function getProductPrice(product, key) {
        var value = product[key];
        if (!value && product.price_min) value = product.price_min;
        if (typeof value === 'string') return value;
        if (typeof value === 'number') return vsFormatMoney(value);
        return '';
      }

      function openPanel(html) {
        panel.innerHTML = html;
        panel.classList.add('vs-open');
      }

      function closePanel() {
        panel.classList.remove('vs-open');
        panel.innerHTML = '';
      }

      function renderProducts(products, query) {
        var normalizedQuery = query.trim().toLowerCase();
        var sorted = products.slice().sort(function(a, b) {
          var aTitle = (a.title || '').trim().toLowerCase();
          var bTitle = (b.title || '').trim().toLowerCase();
          var aStarts = aTitle.indexOf(normalizedQuery) === 0 ? 0 : 1;
          var bStarts = bTitle.indexOf(normalizedQuery) === 0 ? 0 : 1;
          return aStarts - bStarts;
        });

        if (!sorted.length) {
          openPanel('<div class="vs-search-suggestions__empty">ما في منتجات مطابقة</div>');
          return;
        }

        var html = sorted.map(function(product) {
          var image = vsEscapeText(getProductImage(product));
          var price = getProductPrice(product, 'price');
          var compare = getProductPrice(product, 'compare_at_price');
          var url = vsEscapeText(product.url || '#');

          return '<a class="vs-search-suggestions__item" href="' + url + '">' +
            (image ? '<img class="vs-search-suggestions__img" src="' + image + '" alt="">' : '<span class="vs-search-suggestions__img"></span>') +
            '<span class="vs-search-suggestions__body">' +
              '<span class="vs-search-suggestions__title">' + vsEscapeText(product.title) + '</span>' +
              '<span class="vs-search-suggestions__prices">' +
                (price ? '<span>' + vsEscapeText(price) + '</span>' : '') +
                (compare && compare !== price ? '<span class="vs-search-suggestions__compare">' + vsEscapeText(compare) + '</span>' : '') +
              '</span>' +
            '</span>' +
          '</a>';
        }).join('');

        openPanel(html);
      }

      function fetchSuggestions(query) {
        if (localProducts.length) {
          var normalizedQuery = query.trim().toLowerCase();
          var localMatches = localProducts.filter(function(product) {
            return (product.title || '').toLowerCase().indexOf(normalizedQuery) !== -1;
          }).slice(0, 8);
          renderProducts(localMatches, query);
          return;
        }

        if (controller) controller.abort();
        controller = new AbortController();

        openPanel('<div class="vs-search-suggestions__loading">جاري البحث...</div>');

        var params = new URLSearchParams();
        params.set('q', query);
        params.set('resources[type]', 'product');
        params.set('resources[limit]', '8');
        params.set('resources[options][unavailable_products]', 'last');
        params.set('resources[options][fields]', 'title,product_type,variants.title,vendor');

        fetch('/search/suggest.json?' + params.toString(), {
          signal: controller.signal,
          headers: { 'Accept': 'application/json' }
        })
        .then(function(response) {
          if (!response.ok) throw new Error('search-failed');
          return response.json();
        })
        .then(function(data) {
          var products = (((data || {}).resources || {}).results || {}).products || [];
          renderProducts(products, query);
        })
        .catch(function(error) {
          if (error.name === 'AbortError') return;
          openPanel('<div class="vs-search-suggestions__empty">تعذر تحميل الاقتراحات</div>');
        });
      }

      input.addEventListener('input', function() {
        var query = input.value.trim();
        window.clearTimeout(timer);
        if (query.length < 1) {
          closePanel();
          return;
        }
        timer = window.setTimeout(function() {
          fetchSuggestions(query);
        }, 180);
      });

      input.addEventListener('focus', function() {
        if (input.value.trim().length > 0 && panel.innerHTML.trim()) {
          panel.classList.add('vs-open');
        }
      });

      document.addEventListener('click', function(e) {
        if (!form.contains(e.target)) closePanel();
      });

      input.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') closePanel();
      });
    });
  }

  /* ---- Cart Drawer ---- */
  function initCartDrawer() {
    var cartBtn = document.querySelector('[data-vs-cart-toggle]');
    var cartDrawer = document.querySelector('.vs-cart-drawer');
    var overlay = document.querySelector('.vs-overlay');
    if (!cartBtn || !cartDrawer) return;
    if (cartBtn.getAttribute('data-vs-cart-bound') === 'true') return;
    cartBtn.setAttribute('data-vs-cart-bound', 'true');

    function openCart() {
      cartDrawer.classList.add('vs-open');
      document.body.classList.add('vs-cart-open');
      if (overlay) overlay.classList.add('vs-open');
      document.body.style.overflow = 'hidden';
      loadCartContent();
    }
    function closeCart() {
      cartDrawer.classList.remove('vs-open');
      document.body.classList.remove('vs-cart-open');
      if (overlay) overlay.classList.remove('vs-open');
      document.body.style.overflow = '';
    }
    var closeBtn = cartDrawer.querySelector('.vs-cart-drawer__close');
    cartBtn.addEventListener('click', function(e) {
      e.preventDefault();
      openCart();
    });
    if (closeBtn) closeBtn.addEventListener('click', closeCart);
    if (overlay) overlay.addEventListener('click', closeCart);
  }

  /* ---- Full category-name search ---- */
  function initCollectionSearch() {
    document.querySelectorAll('[data-vs-category-search]').forEach(function(form) {
      if (form.getAttribute('data-vs-category-search-bound') === 'true') return;
      form.setAttribute('data-vs-category-search-bound', 'true');

      var input = form.querySelector('input[type="search"]');
      var indexScript = document.querySelector('[data-vs-collection-search-index]');
      if (!input || !indexScript) return;

      var collections = [];
      try {
        collections = JSON.parse(indexScript.textContent || '[]');
      } catch (error) {
        collections = [];
      }

      function normalize(value) {
        return String(value || '')
          .trim()
          .toLowerCase()
          .replace(/[\u064B-\u065F\u0670]/g, '')
          .replace(/[أإآ]/g, 'ا')
          .replace(/ة/g, 'ه')
          .replace(/[-_]+/g, ' ')
          .replace(/\s+/g, ' ');
      }

      var categoryAliases = {
        'adobe': 'adobe',
        'ادوبي': 'adobe',
        'canva': 'canva',
        'كانفا': 'canva',
        'chatgpt': 'chatgpt',
        'chat gpt': 'chatgpt',
        'شات جي بي تي': 'chatgpt',
        'شاتجبت': 'chatgpt',
        'gemini': 'gemini',
        'جيمناي': 'gemini',
        'جيميناي': 'gemini',
        'freepik': 'freepik',
        'free pik': 'freepik',
        'فري بيك': 'freepik',
        'فريبيك': 'freepik',
        'envato': 'envato',
        'انفاتو': 'envato',
        'office': 'office',
        'microsoft office': 'office',
        'اوفيس': 'office',
        'مايكروسوفت اوفيس': 'office',
        'gaming': 'gaming',
        'games': 'gaming',
        'العاب': 'gaming',
        'الالعاب': 'gaming',
        'لينكد ان': 'linkedin',
        'لينكدان': 'linkedin',
        'لينكد': 'linkedin',
        'اوتودسك': 'autodesk',
        'جرامرلي': 'grammarly',
        'غرامرلي': 'grammarly',
        'ويندوز': 'windows'
      };

      function categoryKey(value) {
        var normalizedValue = normalize(value);
        return categoryAliases[normalizedValue] || normalizedValue;
      }

      form.addEventListener('submit', function(event) {
        var query = normalize(input.value);
        if (!query) {
          event.preventDefault();
          input.focus();
          return;
        }

        event.preventDefault();
        var queryKey = categoryKey(query);

        // Best collection wins: exact name/handle, then a whole word of it
        // ("ادوبي" -> "ادوبي Adobe"), then a partial match.
        var matchedCollection = null;
        var bestScore = 0;
        collections.forEach(function(collection) {
          var title = normalize(collection.title);
          var handle = normalize(decodeURIComponent(collection.handle || ''));
          var words = (title + ' ' + handle).split(' ');
          var score = 0;
          if (categoryKey(title) === queryKey || categoryKey(handle) === queryKey) {
            score = 3;
          } else if (words.some(function(word) { return word === query || categoryKey(word) === queryKey; })) {
            score = 2;
          } else if (query.length >= 3 && (title.indexOf(query) !== -1 || handle.indexOf(query) !== -1)) {
            score = 1;
          }
          if (score > bestScore) {
            bestScore = score;
            matchedCollection = collection;
          }
        });

        if (matchedCollection && matchedCollection.url) {
          window.location.assign(matchedCollection.url);
          return;
        }

        // No matching category: filter the all-products page by the words typed.
        window.location.assign('/search?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(input.value.trim()));
      });
    });
  }

  /* ---- Header categories menu ---- */
  function initHeaderCategories() {
    document.querySelectorAll('[data-vs-category-search]').forEach(function(form) {
      var toggle = form.querySelector('[data-vs-categories-toggle]');
      var menu = form.querySelector('[data-vs-categories-menu]');
      if (!toggle || !menu || toggle.getAttribute('data-vs-categories-bound') === 'true') return;
      toggle.setAttribute('data-vs-categories-bound', 'true');

      function closeMenu(returnFocus) {
        form.classList.remove('vs-categories-open');
        toggle.setAttribute('aria-expanded', 'false');
        menu.setAttribute('aria-hidden', 'true');
        if (returnFocus) toggle.focus();
      }

      toggle.addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        var willOpen = !form.classList.contains('vs-categories-open');
        form.classList.toggle('vs-categories-open', willOpen);
        toggle.setAttribute('aria-expanded', String(willOpen));
        menu.setAttribute('aria-hidden', String(!willOpen));
      });

      document.addEventListener('click', function(event) {
        if (!form.contains(event.target)) closeMenu(false);
      });

      document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape' && form.classList.contains('vs-categories-open')) {
          closeMenu(true);
        }
      });
    });
  }

  /* ---- Filter frontpage products for unmatched search terms ---- */
  function initCollectionResultFilter() {
    var collectionPage = document.querySelector('[data-vs-frontpage-collection]');
    if (!collectionPage || collectionPage.getAttribute('data-vs-search-filter-bound') === 'true') return;
    collectionPage.setAttribute('data-vs-search-filter-bound', 'true');

    var query = new URLSearchParams(window.location.search).get('q');
    if (!query) return;

    function normalize(value) {
      return String(value || '')
        .trim()
        .toLowerCase()
        .replace(/[\u064B-\u065F\u0670]/g, '')
        .replace(/[أإآ]/g, 'ا')
        .replace(/ة/g, 'ه')
        .replace(/[-_]+/g, ' ')
        .replace(/\s+/g, ' ');
    }

    var normalizedQuery = normalize(query);
    var productsGrid = collectionPage.querySelector('.vs-collection-page__products');
    if (!normalizedQuery || !productsGrid) return;

    var cards = Array.from(productsGrid.querySelectorAll('.vs-product-card'));
    var matches = 0;
    cards.forEach(function(card) {
      var searchableText = normalize(card.textContent);
      var isMatch = searchableText.indexOf(normalizedQuery) !== -1;
      card.hidden = !isMatch;
      card.classList.toggle('vs-search-filtered-out', !isMatch);
      if (isMatch) matches += 1;
    });

    var summary = document.createElement('div');
    summary.className = 'vs-collection-page__search-summary';
    summary.innerHTML =
      '<span>نتائج البحث عن</span>' +
      '<strong></strong>' +
      '<small></small>';
    summary.querySelector('strong').textContent = '«' + query.trim() + '»';
    summary.querySelector('small').textContent =
      matches > 0 ? matches + ' منتج مطابق' : 'لا توجد منتجات مطابقة';
    productsGrid.parentNode.insertBefore(summary, productsGrid);

    if (matches === 0) {
      collectionPage.classList.add('vs-search-no-results');
      var empty = document.createElement('div');
      empty.className = 'vs-collection-page__empty';
      empty.textContent = 'لا توجد منتجات مطابقة لعبارة البحث.';
      empty.classList.add('vs-collection-page__empty--search');
      empty.textContent = '';

      var emptyTitle = document.createElement('strong');
      emptyTitle.textContent = 'غير متوفر';

      var emptyLink = document.createElement('a');
      emptyLink.href = '/collections/all';
      emptyLink.textContent = 'اضغط هنا لكشف عن منتجات جديدة';

      empty.appendChild(emptyTitle);
      empty.appendChild(emptyLink);
      productsGrid.parentNode.insertBefore(empty, productsGrid.nextSibling);
      productsGrid.hidden = true;
    }
  }

  /* ---- FAQ Accordion ---- */
  function initFAQ() {
    var questions = document.querySelectorAll('.vs-faq__question');
    questions.forEach(function(q) {
      if (q.getAttribute('data-vs-faq-bound') === 'true') return;
      q.setAttribute('data-vs-faq-bound', 'true');
      q.addEventListener('click', function() {
        var item = q.parentElement;
        var isOpen = item.classList.contains('vs-open');
        var faq = q.closest('.vs-faq');

        faq.querySelectorAll('.vs-faq__item').forEach(function(i) {
          i.classList.remove('vs-open');
          var button = i.querySelector('.vs-faq__question');
          if (button) button.setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          item.classList.add('vs-open');
          q.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ---- Testimonials Slider ---- */
  function initTestimonials() {
    var sliders = document.querySelectorAll('[data-vs-testimonials]');
    sliders.forEach(function(slider) {
      if (slider.getAttribute('data-vs-testimonials-bound') === 'true') return;
      slider.setAttribute('data-vs-testimonials-bound', 'true');
      var track = slider.querySelector('.vs-testimonials__track');
      var dots = slider.querySelectorAll('.vs-testimonials__dot');
      var items = slider.querySelectorAll('.vs-testimonial');
      if (!track || items.length === 0) return;

      var current = 0;
      var itemsPerView = window.innerWidth > 1024 ? 4 : (window.innerWidth >= 768 ? 2 : 1);
      var maxIndex = Math.max(0, items.length - itemsPerView);

      dots.forEach(function(dot, index) {
        dot.hidden = index > maxIndex;
      });

      function goTo(index) {
        current = Math.max(0, Math.min(index, maxIndex));
        var itemWidth = items[0].offsetWidth + 16;
        var isRTL = document.documentElement.dir === 'rtl';
        var offset = current * itemWidth;
        track.style.transform = isRTL ? 'translateX(' + offset + 'px)' : 'translateX(-' + offset + 'px)';
        dots.forEach(function(d, i) {
          d.classList.toggle('vs-active', i === current);
        });
      }

      dots.forEach(function(dot, i) {
        dot.addEventListener('click', function() { goTo(i); });
      });

      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var designMode = window.Shopify && window.Shopify.designMode;
      var autoPlay = null;
      if (maxIndex > 0 && !reduceMotion && !designMode) {
        autoPlay = setInterval(function() {
          current = current >= maxIndex ? 0 : current + 1;
          goTo(current);
        }, 5000);
        slider.addEventListener('mouseenter', function() { clearInterval(autoPlay); });
      }
      goTo(0);
    });
  }

  /* ---- Stats Counter Animation ---- */
  function initStatsCounter() {
    var stats = Array.prototype.filter.call(document.querySelectorAll('[data-vs-counter]'), function(stat) {
      return stat.getAttribute('data-vs-counter-bound') !== 'true';
    });
    if (stats.length === 0) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var target = parseInt(el.getAttribute('data-vs-counter'), 10);
          var suffix = el.getAttribute('data-vs-suffix') || '';
          var duration = 1000;
          var start = 0;
          var startTime = null;

          function animate(timestamp) {
            if (!startTime) startTime = timestamp;
            var progress = Math.min((timestamp - startTime) / duration, 1);
            var value = Math.floor(progress * target);
            el.textContent = value.toLocaleString() + suffix;
            if (progress < 1) {
              requestAnimationFrame(animate);
            } else {
              el.textContent = target.toLocaleString() + suffix;
            }
          }
          requestAnimationFrame(animate);
          observer.unobserve(el);
        }
      });
    }, { threshold: 0.5 });

    stats.forEach(function(s) {
      s.setAttribute('data-vs-counter-bound', 'true');
      observer.observe(s);
    });
  }

  /* ---- Product Gallery ---- */
  function initProductGallery() {
    var thumbs = document.querySelectorAll('.vs-product-gallery__thumb');
    var mainImg = document.querySelector('.vs-product-gallery__main img');
    if (!thumbs.length || !mainImg) return;

    thumbs.forEach(function(thumb) {
      if (thumb.getAttribute('data-vs-gallery-bound') === 'true') return;
      thumb.setAttribute('data-vs-gallery-bound', 'true');
      thumb.addEventListener('click', function() {
        var img = thumb.querySelector('img');
        if (img) {
          // Swap to the full-size responsive image (the old `_72x72` replace no
          // longer matched CDN URLs, so the 72px thumbnail was being upscaled).
          var fullSrc = img.getAttribute('data-vs-full-src');
          if (fullSrc) {
            mainImg.srcset = img.getAttribute('data-vs-full-srcset') || '';
            mainImg.src = fullSrc;
            if (img.getAttribute('data-vs-full-width')) mainImg.width = img.getAttribute('data-vs-full-width');
            if (img.getAttribute('data-vs-full-height')) mainImg.height = img.getAttribute('data-vs-full-height');
          } else {
            mainImg.src = img.src;
          }
          mainImg.alt = img.alt;
          thumbs.forEach(function(t) { t.classList.remove('vs-active'); });
          thumb.classList.add('vs-active');
        }
      });
    });
  }

  /* ---- Product Tabs ---- */
  function initProductTabs() {
    var tabs = document.querySelectorAll('.vs-product-tabs__tab');
    var contents = document.querySelectorAll('.vs-product-tabs__content');
    if (!tabs.length) return;

    tabs.forEach(function(tab) {
      if (tab.getAttribute('data-vs-tab-bound') === 'true') return;
      tab.setAttribute('data-vs-tab-bound', 'true');
      tab.addEventListener('click', function() {
        var target = tab.getAttribute('data-tab');
        tabs.forEach(function(t) { t.classList.remove('vs-active'); });
        contents.forEach(function(c) { c.classList.remove('vs-active'); });
        tab.classList.add('vs-active');
        var content = document.querySelector('[data-tab-content="' + target + '"]');
        if (content) content.classList.add('vs-active');
      });
    });
  }

  /* ---- Quick Add to Cart ---- */
  function initQuickAdd() {
    if (document.documentElement.getAttribute('data-vs-quick-add-bound') === 'true') return;
    document.documentElement.setAttribute('data-vs-quick-add-bound', 'true');

    var modal = document.querySelector('[data-vs-quick-add-modal]');
    var modalForm = modal ? modal.querySelector('[data-vs-quick-add-form]') : null;
    var modalProduct = modal ? modal.querySelector('[data-vs-quick-add-product]') : null;
    var modalError = modal ? modal.querySelector('[data-vs-quick-add-error]') : null;
    var modalClose = modal ? modal.querySelector('[data-vs-quick-add-close]') : null;
    var pendingQuickAdd = null;
    var quickRequiredError = modal ? modal.getAttribute('data-required-error') : '';
    var quickAddError = modal ? modal.getAttribute('data-add-error') : '';

    function setQuickButtonLoading(btn) {
      if (!btn) return;
      if (!btn.getAttribute('data-vs-original-html')) {
        btn.setAttribute('data-vs-original-html', btn.innerHTML);
      }
      btn.disabled = true;
      btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 12a9 9 0 11-6.219-8.56" stroke-linecap="round"/></svg>';
    }

    function restoreQuickButton(btn) {
      if (!btn) return;
      btn.disabled = false;
      btn.classList.remove('vs-added');
      btn.innerHTML = btn.getAttribute('data-vs-original-html') || '<span>إضافة للسلة</span>';
    }

    function openQuickModal(data) {
      if (!modal || !modalForm) return false;
      pendingQuickAdd = data;
      modal.classList.add('vs-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('vs-quick-add-open');
      document.body.style.overflow = 'hidden';
      if (modalProduct) modalProduct.textContent = data.title || '';
      if (modalError) modalError.textContent = '';
      modalForm.reset();
      var input = modalForm.querySelector('[name="whatsapp"]');
      if (input) setTimeout(function() { input.focus(); }, 80);
      return true;
    }

    function closeQuickModal() {
      if (!modal) return;
      modal.classList.remove('vs-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('vs-quick-add-open');
      document.body.style.overflow = '';
      pendingQuickAdd = null;
    }

    function openCartAfterQuickAdd() {
      var cartDrawer = document.querySelector('.vs-cart-drawer');
      var overlay = document.querySelector('.vs-overlay');
      if (cartDrawer) {
        cartDrawer.classList.add('vs-open');
        document.body.classList.add('vs-cart-open');
        if (overlay) overlay.classList.add('vs-open');
        document.body.style.overflow = 'hidden';
        loadCartContent();
      }
    }

    function addQuickItem(variantId, properties, btn) {
      setQuickButtonLoading(btn);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: parseInt(variantId, 10),
          quantity: 1,
          properties: properties
        })
      })
      .then(function(r) {
        if (!r.ok) throw new Error('cart-add-failed');
        return r.json();
      })
      .then(function() {
        if (btn) {
          btn.classList.add('vs-added');
          btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 13l4 4L19 7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        }
        closeQuickModal();
        updateCartCountOnly();
        showCartAddedToast();
        setTimeout(function() { restoreQuickButton(btn); }, 1600);
      })
      .catch(function() {
        restoreQuickButton(btn);
        if (modalError) modalError.textContent = quickAddError || 'تعذر إضافة المنتج، حاول مرة ثانية.';
      });
    }

    if (modalClose) {
      modalClose.addEventListener('click', closeQuickModal);
    }

    if (modal) {
      modal.addEventListener('click', function(e) {
        if (e.target === modal) closeQuickModal();
      });
    }

    if (modalForm) {
      modalForm.addEventListener('submit', function(e) {
        e.preventDefault();
        if (!pendingQuickAdd) return;

        var whatsapp = modalForm.querySelector('[name="whatsapp"]').value.trim();
        var agree = modalForm.querySelector('[name="agree"]').value;

        if (!whatsapp || !agree) {
          if (modalError) modalError.textContent = quickRequiredError || 'عبّي رقم الواتساب والموافقة قبل الإضافة.';
          return;
        }

        addQuickItem(pendingQuickAdd.variantId, {
          'رقم الواتساب': whatsapp,
          'الموافقة على وصف المنتج': agree
        }, pendingQuickAdd.button);
      });
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal && modal.classList.contains('vs-open')) closeQuickModal();
    });

    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-vs-quick-add]');
      if (!btn) return;
      e.preventDefault();
      var variantId = btn.getAttribute('data-vs-quick-add');
      var title = btn.getAttribute('data-vs-product-title') || '';

      if (openQuickModal({ variantId: variantId, title: title, button: btn })) {
        return;
      }

      btn.textContent = '';
      btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 12a9 9 0 11-6.219-8.56" stroke-linecap="round"/><path d="M9 12l2 2 4-4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        btn.classList.add('vs-added');
        btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 13l4 4L19 7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        // Update cart count
        fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
          var countEl = document.querySelector('.vs-header__cart-count');
          if (countEl) countEl.textContent = cart.item_count;
          showCartAddedToast();
        });
        setTimeout(function() {
          btn.classList.remove('vs-added');
          btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        }, 2000);
      })
      .catch(function() {
        btn.innerHTML = 'إضافة للسلة';
      });
    });
  }

  /* ---- Product row controls ---- */
  function initProductRowControls() {
    document.querySelectorAll('.vs-products-grid').forEach(function(grid) {
      if (grid.getAttribute('data-vs-controls-ready') === 'true') return;
      var row = grid.closest('.vs-products-row');
      var controls = row ? row.querySelector('.vs-products-controls') : grid.nextElementSibling;

      if (!row) {
        row = document.createElement('div');
        row.className = 'vs-products-row';
        grid.parentNode.insertBefore(row, grid);
        row.appendChild(grid);
      }

      if (!controls || !controls.classList.contains('vs-products-controls')) {
        controls = document.createElement('div');
        controls.className = 'vs-products-controls';
        row.appendChild(controls);
      } else if (controls.parentNode !== row) {
        row.appendChild(controls);
      }

      controls.innerHTML = '<button type="button" class="vs-products-controls__arrow vs-products-controls__arrow--prev" data-vs-products-prev aria-label="المنتجات السابقة"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M19 12H5"/><path d="M12 5l-7 7 7 7"/></svg></button><button type="button" class="vs-products-controls__arrow vs-products-controls__arrow--next" data-vs-products-next aria-label="المنتجات التالية"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M5 12h14"/><path d="M12 5l7 7-7 7"/></svg></button>';

      function updateControlsVisibility() {
        var hasOverflow = grid.scrollWidth > grid.clientWidth + 4;
        controls.hidden = !hasOverflow;
        controls.setAttribute('aria-hidden', hasOverflow ? 'false' : 'true');
      }

      grid.setAttribute('data-vs-controls-ready', 'true');
      grid.scrollLeft = 0;
      window.requestAnimationFrame(updateControlsVisibility);
      if ('ResizeObserver' in window) {
        var productsGridObserver = new ResizeObserver(updateControlsVisibility);
        productsGridObserver.observe(grid);
      } else {
        window.addEventListener('resize', updateControlsVisibility, { passive: true });
      }
    });

    var buttons = document.querySelectorAll('[data-vs-products-next], [data-vs-products-prev]');
    buttons.forEach(function(btn) {
      if (btn.getAttribute('data-vs-products-bound') === 'true') return;
      btn.setAttribute('data-vs-products-bound', 'true');

      btn.addEventListener('click', function() {
        var wrap = btn.closest('.vs-products-row') || btn.closest('.vs-container') || btn.closest('.vs-section');
        var grid = wrap ? wrap.querySelector('.vs-products-grid') : null;
        if (!grid) return;

        var step = Math.max(220, Math.round(grid.clientWidth * 0.72));
        var direction = btn.hasAttribute('data-vs-products-prev') ? -1 : 1;
        var isRtl = window.getComputedStyle(grid).direction === 'rtl';
        var physicalDirection = isRtl ? -direction : direction;
        var maxScroll = grid.scrollWidth - grid.clientWidth;
        var current = Math.abs(grid.scrollLeft);
        var tolerance = 4;

        if (direction > 0 && current >= maxScroll - tolerance) {
          grid.scrollTo({ left: 0, behavior: 'smooth' });
          return;
        }

        if (direction < 0 && current <= tolerance) {
          grid.scrollTo({ left: isRtl ? -maxScroll : maxScroll, behavior: 'smooth' });
          return;
        }

        grid.scrollBy({ left: step * physicalDirection, behavior: 'smooth' });
      });
    });
  }

  function loadCartContent() {
    var cartBody = document.querySelector('.vs-cart-drawer__body');
    var cartTotal = document.querySelector('.vs-cart-drawer__total span:last-child');
    var cartDrawer = document.querySelector('[data-vs-cart-drawer]');
    if (!cartBody) return;
    var emptyText = cartDrawer ? cartDrawer.getAttribute('data-empty-text') : '';
    var quantityText = cartDrawer ? cartDrawer.getAttribute('data-quantity-text') : '';
    var errorText = cartDrawer ? cartDrawer.getAttribute('data-error-text') : '';

    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        document.querySelectorAll('.vs-header__cart-count').forEach(function(countEl) {
          countEl.textContent = cart.item_count || 0;
        });

        if (cartTotal) {
          cartTotal.textContent = vsFormatMoney(cart.total_price || 0);
        }

        if (!cart.items || cart.items.length === 0) {
          cartBody.innerHTML = '<div class="vs-cart-empty"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6" stroke-linecap="round" stroke-linejoin="round"/></svg><p>' + vsEscapeText(emptyText || 'السلة فارغة') + '</p></div>';
          return;
        }

        var html = '';
        cart.items.forEach(function(item) {
          var image = item.image || '';
          var title = vsEscapeText(item.product_title || item.title);
          var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<p style="font-size:12px;color:#6b7280;margin:2px 0 0;">' + vsEscapeText(item.variant_title) + '</p>' : '';
          var properties = '';

          if (item.properties) {
            Object.keys(item.properties).forEach(function(key) {
              if (!key || key.charAt(0) === '_' || !item.properties[key]) return;
              properties += '<p style="font-size:11px;color:#6b7280;margin:2px 0 0;">' + vsEscapeText(key) + ': ' + vsEscapeText(item.properties[key]) + '</p>';
            });
          }

          html += '<div class="vs-cart-item" style="display:flex;gap:12px;padding:12px 0;border-bottom:1px solid #e5e7eb;">' +
            (image ? '<img src="' + vsEscapeText(image) + '" alt="" style="width:62px;height:62px;border-radius:10px;object-fit:contain;background:#f5f5f5;border:1px solid rgba(0,190,235,.12);">' : '<div style="width:62px;height:62px;border-radius:10px;background:#f5f5f5;border:1px solid rgba(0,190,235,.12);"></div>') +
            '<div style="flex:1;min-width:0;"><p style="font-size:13px;font-weight:800;margin:0 0 4px;color:#063A55;line-height:1.35;">' + title + '</p>' +
            variant +
            '<p style="font-size:14px;font-weight:900;color:#00BEEB;margin:5px 0 0;">' + vsFormatMoney(item.final_line_price || item.line_price || item.price) + '</p>' +
            '<p style="font-size:12px;color:#6b7280;margin:3px 0 0;">' + vsEscapeText(quantityText || 'الكمية') + ': ' + item.quantity + '</p>' +
            properties +
            '</div></div>';
        });

        cartBody.innerHTML = html;
      })
      .catch(function() {
        cartBody.innerHTML = '<div class="vs-cart-empty"><p>' + vsEscapeText(errorText || 'تعذر تحميل السلة، حدث الصفحة وحاول مرة ثانية.') + '</p></div>';
      });
  }

  /* ---- Sticky Header Shadow ---- */
  /* ---- Header account button: instant press feedback on touch ----
     iOS Safari does not apply :active to links without a touch listener,
     so the pressed state is toggled from pointer events (passive, so the
     tap itself is never delayed). */
  // /account redirects to Shopify customer accounts on shopify.com; open that
  // connection on touch so the redirect does not start from a cold socket.
  var accountHostWarmed = false;
  function warmAccountHost() {
    if (accountHostWarmed) return;
    accountHostWarmed = true;
    var link = document.createElement('link');
    link.rel = 'preconnect';
    link.href = 'https://shopify.com';
    document.head.appendChild(link);
  }

  /* ---- Horizontal rows: load all of a row's images once it nears the screen ----
     Product rows scroll sideways and the subcategory strip moves on its own;
     lazy images inside them only start downloading when they slide into view,
     so they popped in late on phones. Rows are still skipped until needed. */
  function initRowImageLoading() {
    var rows = Array.prototype.filter.call(
      document.querySelectorAll('.vs-products-grid, .vs-subcat__viewport'),
      function(row) { return row.getAttribute('data-vs-row-images') !== 'true'; }
    );
    if (!rows.length) return;

    function loadRow(row) {
      row.querySelectorAll('img[loading="lazy"]').forEach(function(img) {
        img.loading = 'eager';
      });
    }

    if (!('IntersectionObserver' in window)) {
      rows.forEach(loadRow);
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        loadRow(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '600px 0px' });

    rows.forEach(function(row) {
      row.setAttribute('data-vs-row-images', 'true');
      observer.observe(row);
    });
  }

  function initAccountButtonFeedback() {
    document.querySelectorAll('.vs-header__account-btn').forEach(function(btn) {
      if (btn.getAttribute('data-vs-press-bound') === 'true') return;
      btn.setAttribute('data-vs-press-bound', 'true');
      function release() { btn.classList.remove('is-pressed'); }
      btn.addEventListener('pointerdown', function() {
        btn.classList.add('is-pressed');
        warmAccountHost();
      }, { passive: true });
      btn.addEventListener('pointerup', release, { passive: true });
      btn.addEventListener('pointercancel', release, { passive: true });
      btn.addEventListener('pointerleave', release, { passive: true });
      window.addEventListener('pageshow', release);
    });
  }

  function initStickyHeader() {
    var header = document.querySelector('.vs-header');
    var headerSection = document.querySelector('.shopify-section.vs-section-header');
    var announcement = document.querySelector('.vs-announcement');
    if (!header) return;
    if (header.getAttribute('data-vs-sticky-bound') === 'true') return;
    header.setAttribute('data-vs-sticky-bound', 'true');
    function updateHeaderOffset() {
      var announcementHeight = announcement ? announcement.offsetHeight : 0;
      document.documentElement.style.setProperty('--vs-header-offset', (announcementHeight + header.offsetHeight) + 'px');
    }
    function updateHeaderTop() {
      var announcementHeight = announcement ? announcement.offsetHeight : 0;
      document.documentElement.style.setProperty('--vs-header-top', announcementHeight + 'px');
    }
    function updateHeaderState() {
      header.classList.toggle('vs-header--scrolled', window.scrollY > 10);
      if (headerSection) headerSection.classList.toggle('vs-header-section--scrolled', window.scrollY > 10);
      updateHeaderTop();
      updateHeaderOffset();
    }
    updateHeaderState();
    var scrollTicking = false;
    window.addEventListener('scroll', function() {
      if (scrollTicking) return;
      scrollTicking = true;
      window.requestAnimationFrame(function() {
        updateHeaderState();
        scrollTicking = false;
      });
    }, { passive: true });
    window.addEventListener('resize', function() {
      updateHeaderTop();
      updateHeaderOffset();
    });
    if ('ResizeObserver' in window) {
      var headerObserver = new ResizeObserver(updateHeaderOffset);
      headerObserver.observe(header);
      if (announcement) {
        var announcementObserver = new ResizeObserver(function() {
          updateHeaderTop();
          updateHeaderOffset();
        });
        announcementObserver.observe(announcement);
      }
    }
  }

  /* ---- PDP interactions ---- */
  function initPdp() {
    var descPill = document.querySelector('[data-vs-scroll-desc]');
    if (descPill && descPill.getAttribute('data-vs-pdp-bound') !== 'true') {
      descPill.setAttribute('data-vs-pdp-bound', 'true');
      descPill.addEventListener('click', function() {
        var descTab = document.querySelector('.vs-product-tabs__tab[data-tab="description"]');
        if (descTab) descTab.click();
        var tabs = document.querySelector('.vs-product-tabs');
        if (tabs) tabs.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
    var shareBtn = document.querySelector('[data-vs-share]');
    if (shareBtn && shareBtn.getAttribute('data-vs-pdp-bound') !== 'true') {
      shareBtn.setAttribute('data-vs-pdp-bound', 'true');
      shareBtn.addEventListener('click', function() {
        if (navigator.share) {
          navigator.share({ title: document.title, url: window.location.href }).catch(function() {});
        } else {
          navigator.clipboard && navigator.clipboard.writeText(window.location.href);
        }
      });
    }
    var wishBtn = document.querySelector('[data-vs-wishlist]');
    if (wishBtn && wishBtn.getAttribute('data-vs-pdp-bound') !== 'true') {
      wishBtn.setAttribute('data-vs-pdp-bound', 'true');
      wishBtn.addEventListener('click', function() {
        wishBtn.classList.toggle('vs-active');
      });
    }
    var qtyWrap = document.querySelector('.vs-pdp__qty');
    if (qtyWrap && qtyWrap.getAttribute('data-vs-pdp-bound') !== 'true') {
      qtyWrap.setAttribute('data-vs-pdp-bound', 'true');
      var qtyInput = qtyWrap.querySelector('.vs-pdp__qty-input');
      if (!qtyInput) return;
      var normalizeQtyDigits = function(value) {
        return String(value)
          .replace(/[٠-٩]/g, function(digit) { return String(digit.charCodeAt(0) - 1632); })
          .replace(/[۰-۹]/g, function(digit) { return String(digit.charCodeAt(0) - 1776); })
          .replace(/[^0-9]/g, '');
      };
      qtyInput.value = normalizeQtyDigits(qtyInput.value) || '1';
      qtyInput.addEventListener('input', function() {
        qtyInput.value = normalizeQtyDigits(qtyInput.value);
      });
      qtyInput.addEventListener('change', function() {
        qtyInput.value = String(Math.max(1, parseInt(normalizeQtyDigits(qtyInput.value), 10) || 1));
      });
      qtyWrap.querySelectorAll('[data-qty]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var val = parseInt(normalizeQtyDigits(qtyInput.value), 10) || 1;
          if (btn.getAttribute('data-qty') === 'plus') { val++; }
          else { val = Math.max(1, val - 1); }
          qtyInput.value = String(val);
        });
      });
    }

    var productForm = document.querySelector('#vs-product-form');
    if (productForm && productForm.getAttribute('data-vs-ajax-bound') !== 'true') {
      productForm.setAttribute('data-vs-ajax-bound', 'true');
      productForm.addEventListener('submit', function(event) {
        var submitter = event.submitter;
        var isBuyNow = !!(submitter && submitter.name === 'return_to');
        var deal = getActiveDeal();
        // "Buy now" without the deal keeps Shopify's native add-and-redirect.
        if (isBuyNow && !deal) return;

        event.preventDefault();
        var addButton = submitter || productForm.querySelector('.vs-product-info__btn-atc');
        if (!addButton || addButton.disabled) return;

        if (!addButton.getAttribute('data-vs-original-html')) {
          addButton.setAttribute('data-vs-original-html', addButton.innerHTML);
        }
        addButton.disabled = true;
        addButton.textContent = 'جاري الإضافة...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(productForm)
        })
          .then(function(response) {
            if (!response.ok) throw new Error('Product add failed');
            return response.json();
          })
          .then(function() {
            return deal ? addDealToCart(deal) : null;
          })
          .then(function() {
            if (isBuyNow) {
              window.location.href = deal.getAttribute('data-cart-url') || '/cart';
              return;
            }
            addButton.textContent = 'تمت الإضافة ✓';
            updateCartCountOnly();
            showCartAddedToast();
            window.setTimeout(function() {
              addButton.disabled = false;
              addButton.innerHTML = addButton.getAttribute('data-vs-original-html');
            }, 1500);
          })
          .catch(function(error) {
            console.error(error);
            addButton.textContent = 'تعذرت الإضافة';
            window.setTimeout(function() {
              addButton.disabled = false;
              addButton.innerHTML = addButton.getAttribute('data-vs-original-html');
            }, 1800);
          });
      });
    }
  }

  /* ---- Product options: pick the matching variant and update id + prices ---- */
  function initPdpVariants() {
    var form = document.querySelector('#vs-product-form');
    var dataScript = form && form.querySelector('[data-vs-variants]');
    if (!dataScript || form.getAttribute('data-vs-variants-bound') === 'true') return;
    form.setAttribute('data-vs-variants-bound', 'true');

    var variants;
    try {
      variants = JSON.parse(dataScript.textContent);
    } catch (error) {
      return;
    }
    var idInput = form.querySelector('[name="id"]');
    var optionGroups = Array.prototype.slice.call(form.querySelectorAll('.vs-pdp__variants'));
    var buttons = form.querySelectorAll('.vs-product-info__btn-atc, .vs-product-info__btn-buy');

    function setText(selector, text) {
      document.querySelectorAll(selector).forEach(function(el) {
        if (text) {
          el.textContent = text;
          el.hidden = false;
        } else {
          el.hidden = true;
        }
      });
    }

    function update() {
      var selected = optionGroups.map(function(group) {
        var checked = group.querySelector('input:checked');
        return checked ? checked.value : null;
      });
      var variant = variants.filter(function(v) {
        return v.options.every(function(value, index) { return value === selected[index]; });
      })[0];
      if (!variant) return;

      idInput.value = variant.id;
      setText('[data-vs-variant-price]', variant.price);
      setText('[data-vs-variant-compare]', variant.compare);
      setText('[data-vs-variant-off]', variant.off > 0 ? '-' + variant.off + '%' : '');
      setText('[data-vs-bundle-total]', variant.bundleTotal);
      setText('[data-vs-bundle-final]', variant.bundleFinal);
      setText('[data-vs-bundle-saving]', variant.bundleSaving);

      buttons.forEach(function(button) { button.disabled = !variant.available; });

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    optionGroups.forEach(function(group) {
      group.addEventListener('change', update);
    });
  }

  /* ---- Buttons that open a product tab (description, reviews) and scroll to it ---- */
  function initPdpJumpTabs() {
    document.querySelectorAll('[data-vs-jump-tab]').forEach(function(button) {
      if (button.getAttribute('data-vs-jump-bound') === 'true') return;
      button.setAttribute('data-vs-jump-bound', 'true');
      button.addEventListener('click', function() {
        var target = button.getAttribute('data-vs-jump-tab');
        var tab = document.querySelector('.vs-product-tabs__tab[data-tab="' + target + '"]');
        if (tab) tab.click();
        var tabs = document.querySelector('.vs-product-tabs');
        if (tabs) tabs.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ---- Product page "complete your order" deal ----
     A switch on the deal ticket. When it is on, the product form's add / buy buttons
     also add the partner product and apply the deal's discount code to the cart
     (keeping any codes already there). */
  function getActiveDeal() {
    var deal = document.querySelector('[data-vs-bundle]');
    var toggle = deal && deal.querySelector('[data-vs-bundle-toggle]');
    return toggle && toggle.checked ? deal : null;
  }

  function addDealToCart(deal) {
    var partnerId = parseInt(deal.getAttribute('data-partner-variant'), 10);
    var code = (deal.getAttribute('data-code') || '').trim();
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: partnerId, quantity: 1 }] })
    })
      .then(function(response) {
        if (!response.ok) throw new Error('Deal add failed');
        if (!code) return null;
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            var codes = (cart.discount_codes || [])
              .map(function(entry) { return entry.code; })
              .filter(function(existing) { return existing && existing.toUpperCase() !== code.toUpperCase(); });
            codes.push(code);
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ discount: codes.join(',') })
            });
          });
      });
  }

  function initPdpBundle() {
    document.querySelectorAll('[data-vs-bundle]').forEach(function(deal) {
      if (deal.getAttribute('data-vs-bundle-bound') === 'true') return;
      deal.setAttribute('data-vs-bundle-bound', 'true');
      var toggle = deal.querySelector('[data-vs-bundle-toggle]');
      if (!toggle) return;
      var sync = function() { deal.classList.toggle('is-on', toggle.checked); };
      toggle.addEventListener('change', sync);
      sync();
    });
  }

  /* ---- Theme-styled product select fields ---- */
  function initPdpCustomSelects() {
    document.querySelectorAll('[data-vs-custom-select]').forEach(function(wrapper) {
      if (wrapper.getAttribute('data-vs-custom-select-bound') === 'true') return;
      wrapper.setAttribute('data-vs-custom-select-bound', 'true');

      var select = wrapper.querySelector('[data-vs-native-select]');
      var trigger = wrapper.querySelector('[data-vs-select-trigger]');
      var triggerText = wrapper.querySelector('[data-vs-select-text]');
      var menu = wrapper.querySelector('[data-vs-select-menu]');
      var options = wrapper.querySelectorAll('[data-vs-select-value]');
      if (!select || !trigger || !triggerText || !menu || !options.length) return;

      function closeMenu(restoreFocus) {
        wrapper.classList.remove('vs-open');
        menu.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        if (restoreFocus) trigger.focus();
      }

      function openMenu() {
        wrapper.classList.add('vs-open');
        menu.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
      }

      function syncSelection() {
        var selectedOption = select.options[select.selectedIndex];
        triggerText.textContent = selectedOption ? selectedOption.textContent : '';
        wrapper.classList.toggle('vs-has-value', Boolean(select.value));
        wrapper.classList.remove('vs-invalid');
        options.forEach(function(option) {
          var isSelected = option.getAttribute('data-vs-select-value') === select.value;
          option.classList.toggle('vs-selected', isSelected);
          option.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        });
      }

      trigger.addEventListener('click', function() {
        if (wrapper.classList.contains('vs-open')) closeMenu(false);
        else openMenu();
      });

      trigger.addEventListener('keydown', function(event) {
        if (event.key === 'ArrowDown' || event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openMenu();
          var selected = menu.querySelector('.vs-selected') || options[0];
          if (selected) selected.focus();
        }
      });

      options.forEach(function(option) {
        option.addEventListener('click', function() {
          select.value = option.getAttribute('data-vs-select-value');
          select.dispatchEvent(new Event('change', { bubbles: true }));
          closeMenu(true);
        });
        option.addEventListener('keydown', function(event) {
          if (event.key === 'Escape') {
            event.preventDefault();
            closeMenu(true);
          }
        });
      });

      select.addEventListener('change', syncSelection);
      select.addEventListener('invalid', function(event) {
        event.preventDefault();
        wrapper.classList.add('vs-invalid');
        trigger.focus();
      });
      document.addEventListener('click', function(event) {
        if (!wrapper.contains(event.target)) closeMenu(false);
      });

      syncSelection();
    });
  }

  /* ---- Activation email inside cart line items ---- */
  function initCartActivationEmail() {
    var cartPage = document.querySelector('.vs-cart-page');
    if (!cartPage) return;

    cartPage.querySelectorAll('[data-vs-cart-email-card]').forEach(function(card) {
      if (card.getAttribute('data-vs-email-card-bound') === 'true') return;
      card.setAttribute('data-vs-email-card-bound', 'true');

      var button = card.querySelector('[data-vs-save-cart-email]');
      var input = card.querySelector('[data-vs-cart-email-input]');
      var feedback = card.querySelector('[data-vs-cart-email-feedback]');
      var propertiesScript = card.querySelector('[data-vs-line-properties]');
      if (!button || !input) return;

      input.addEventListener('input', function() {
        input.setCustomValidity('');
        if (feedback) feedback.textContent = '';
      });

      button.addEventListener('click', function() {
        var email = input.value.trim();
        input.value = email;
        input.setCustomValidity('');

        if (!email || !input.checkValidity()) {
          input.setCustomValidity('أدخل بريدًا إلكترونيًا صحيحًا لتفعيل الاشتراك.');
          input.reportValidity();
          if (feedback) feedback.textContent = 'يرجى كتابة بريد إلكتروني صحيح.';
          return;
        }

        var properties = {};
        if (propertiesScript) {
          try {
            properties = JSON.parse(propertiesScript.textContent || '{}');
          } catch (error) {
            properties = {};
          }
        }
        if (!properties || typeof properties !== 'object' || Array.isArray(properties)) {
          properties = {};
        }
        properties['البريد الإلكتروني لتفعيل الاشتراك'] = email;
        var lineNumber = parseInt(card.getAttribute('data-line-number'), 10);
        var changePayload = { properties: properties };
        if (lineNumber > 0) {
          changePayload.line = lineNumber;
        } else {
          changePayload.id = card.getAttribute('data-line-key');
        }

        card.classList.add('is-saving');
        button.disabled = true;
        button.textContent = 'جاري الحفظ...';
        if (feedback) feedback.textContent = '';

        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json; charset=UTF-8',
            'Accept': 'application/json'
          },
          body: JSON.stringify(changePayload)
        })
          .then(function(response) {
            if (!response.ok) throw new Error('Email update failed');
            return response.json();
          })
          .then(function() {
            window.location.reload();
          })
          .catch(function(error) {
            console.error(error);
            card.classList.remove('is-saving');
            button.disabled = false;
            button.textContent = 'حفظ البريد';
            if (feedback) feedback.textContent = 'تعذّر حفظ البريد. حاول مرة أخرى.';
          });
      });
    });

    if (cartPage.getAttribute('data-vs-email-check-bound') !== 'true') {
      cartPage.setAttribute('data-vs-email-check-bound', 'true');
      var cartForm = cartPage.querySelector('form');
      if (cartForm) {
        cartForm.addEventListener('submit', function(event) {
          var missingCard = cartPage.querySelector('.vs-cart-email-card.is-missing');
          if (!missingCard) return;

          event.preventDefault();
          var missingInput = missingCard.querySelector('[data-vs-cart-email-input]');
          var missingFeedback = missingCard.querySelector('[data-vs-cart-email-feedback]');
          if (missingFeedback) {
            missingFeedback.textContent = 'احفظ بريد التفعيل أولًا قبل إتمام الدفع.';
          }
          if (missingInput) {
            missingInput.focus();
            if (!missingInput.value.trim()) missingInput.reportValidity();
          }
          missingCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, true);
      }
    }
  }

  /* ---- Cart page AJAX ---- */
  function initCartPageAjax() {
    var cartPage = document.querySelector('.vs-cart-page');
    if (!cartPage || cartPage.getAttribute('data-vs-cart-page-bound') === 'true') return;
    cartPage.setAttribute('data-vs-cart-page-bound', 'true');
    var attributeSaveTimer = null;

    function saveCartAttributes() {
      var attributes = {};
      cartPage.querySelectorAll('[name^="attributes["]').forEach(function(input) {
        var name = input.getAttribute('name') || '';
        var key = name.slice(11, -1);
        if (!key) return;
        attributes[key] = input.type === 'checkbox'
          ? (input.checked ? input.value : '')
          : input.value.trim();
      });

      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ attributes: attributes })
      }).catch(function(error) {
        console.error(error);
      });
    }

    cartPage.addEventListener('input', function(e) {
      if (!e.target.matches('[name^="attributes["]')) return;
      window.clearTimeout(attributeSaveTimer);
      attributeSaveTimer = window.setTimeout(saveCartAttributes, 450);
    });

    cartPage.addEventListener('change', function(e) {
      if (!e.target.matches('[name^="attributes["]')) return;
      window.clearTimeout(attributeSaveTimer);
      saveCartAttributes();
    });

    cartPage.addEventListener('click', function(e) {
      var action = e.target.closest('.vs-cart-page__qty-btn, .vs-cart-page__remove');
      if (!action) return;
      e.preventDefault();

      var url = new URL(action.href, window.location.origin);
      var itemId = url.searchParams.get('id');
      var quantity = url.searchParams.get('quantity');
      if (!itemId || quantity === null) return;

      cartPage.classList.add('vs-cart-page--loading');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          'Accept': 'application/json'
        },
        body: new URLSearchParams({ id: itemId, quantity: quantity })
      })
        .then(function(response) {
          if (!response.ok) throw new Error('Cart update failed');
          return fetch(window.location.pathname + '?_vs=' + Date.now(), {
            headers: { 'Accept': 'text/html' }
          });
        })
        .then(function(response) { return response.text(); })
        .then(function(html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var updatedCart = doc.querySelector('.vs-cart-page');
          if (updatedCart) {
            cartPage.replaceWith(updatedCart);
            initCartPageAjax();
            initCartActivationEmail();
            initCartCoupon();
          }
          updateCartCountOnly();
        })
        .catch(function(error) {
          console.error(error);
          window.location.href = action.href;
        })
        .finally(function() {
          var currentCart = document.querySelector('.vs-cart-page');
          if (currentCart) currentCart.classList.remove('vs-cart-page--loading');
        });
    });
  }

  /* ---- Cart page discount code ----
     Codes are applied to the Shopify cart itself (cart/update.js `discount`),
     so the discount shown here is the one Shopify carries into checkout.
     Shopify only reports whether a code is applicable, not why it is not. */
  function initCartCoupon() {
    var cartPage = document.querySelector('.vs-cart-page');
    if (!cartPage || cartPage.getAttribute('data-vs-coupon-bound') === 'true') return;
    var box = cartPage.querySelector('[data-vs-coupon]');
    if (!box) return;
    cartPage.setAttribute('data-vs-coupon-bound', 'true');

    var input = box.querySelector('[data-vs-coupon-input]');
    var applyBtn = box.querySelector('[data-vs-coupon-apply]');
    var busy = false;

    function showMessage(text, type) {
      var message = document.querySelector('.vs-cart-page [data-vs-coupon-message]');
      if (!message) return;
      message.textContent = text || '';
      message.hidden = !text;
      message.classList.toggle('is-success', type === 'success');
      message.classList.toggle('is-error', type === 'error');
    }

    function setBusy(state) {
      busy = state;
      var current = document.querySelector('.vs-cart-page');
      if (current) current.classList.toggle('vs-cart-page--coupon-loading', state);
      input.disabled = state;
      applyBtn.disabled = state;
      applyBtn.setAttribute('aria-busy', state ? 'true' : 'false');
      applyBtn.textContent = state ? 'جارٍ التحقق...' : (applyBtn.getAttribute('data-label') || 'تطبيق');
      cartPage.querySelectorAll('[data-vs-coupon-remove]').forEach(function(btn) { btn.disabled = state; });
    }

    function getCart() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function(response) {
          if (!response.ok) throw new Error('Cart fetch failed');
          return response.json();
        });
    }

    function setCodes(codes) {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: codes.join(',') })
      }).then(function(response) {
        if (!response.ok) throw new Error('Discount update failed');
        return response.json();
      });
    }

    function codeList(cart) {
      return (cart.discount_codes || []).filter(function(entry) {
        return entry.applicable;
      }).map(function(entry) { return entry.code; });
    }

    function sameCode(a, b) {
      return String(a).trim().toUpperCase() === String(b).trim().toUpperCase();
    }

    // Re-render the cart section so every total comes from Shopify, then show the result.
    function refreshCart(text, type) {
      return fetch(window.location.pathname + '?_vs=' + Date.now(), { headers: { 'Accept': 'text/html' } })
        .then(function(response) { return response.text(); })
        .then(function(html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var updatedCart = doc.querySelector('.vs-cart-page');
          var currentCart = document.querySelector('.vs-cart-page');
          if (updatedCart && currentCart) {
            currentCart.replaceWith(updatedCart);
            initCartPageAjax();
            initCartActivationEmail();
            initCartCoupon();
          }
          showMessage(text, type);
        });
    }

    function fail(error) {
      console.error(error);
      setBusy(false);
      showMessage('تعذّر التحقق من كود الخصم الآن. تأكد من اتصالك بالإنترنت وحاول مرة أخرى.', 'error');
    }

    function applyCode() {
      if (busy) return;
      var code = input.value.trim();
      input.value = code;
      if (!code) {
        showMessage('أدخل كود الخصم أولًا ثم اضغط «تطبيق».', 'error');
        input.focus();
        return;
      }

      setBusy(true);
      showMessage('', null);
      var previousCodes = [];

      getCart()
        .then(function(cart) {
          previousCodes = codeList(cart);
          if (previousCodes.some(function(existing) { return sameCode(existing, code); })) {
            return { alreadyApplied: true };
          }
          return setCodes(previousCodes.concat(code));
        })
        .then(function(result) {
          if (result.alreadyApplied) {
            setBusy(false);
            showMessage('هذا الكود مطبّق بالفعل على سلتك.', 'success');
            return;
          }
          var entry = (result.discount_codes || []).filter(function(item) {
            return sameCode(item.code, code);
          })[0];

          if (entry && entry.applicable) {
            return refreshCart('تم تطبيق كود الخصم «' + entry.code + '» بنجاح.', 'success');
          }

          // Not accepted: drop it again so the cart only keeps codes that really apply.
          return setCodes(previousCodes).then(function() {
            setBusy(false);
            input.focus();
            input.select();
            showMessage('كود الخصم «' + code + '» غير صالح أو منتهي الصلاحية، أو أن شروطه (مثل الحد الأدنى للطلب أو المنتجات المشمولة) لا تنطبق على سلتك الحالية.', 'error');
          });
        })
        .catch(fail);
    }

    function removeCode(code) {
      if (busy) return;
      setBusy(true);
      getCart()
        .then(function(cart) {
          return setCodes(codeList(cart).filter(function(existing) { return !sameCode(existing, code); }));
        })
        .then(function() {
          return refreshCart('تمت إزالة كود الخصم «' + code + '».', 'success');
        })
        .catch(fail);
    }

    applyBtn.addEventListener('click', applyCode);

    // Enter inside the coupon field applies the code instead of submitting the checkout form.
    input.addEventListener('keydown', function(e) {
      if (e.key !== 'Enter') return;
      e.preventDefault();
      applyCode();
    });

    input.addEventListener('input', function() {
      var message = document.querySelector('.vs-cart-page [data-vs-coupon-message]');
      if (message && message.classList.contains('is-error')) showMessage('', null);
    });

    cartPage.addEventListener('click', function(e) {
      var removeBtn = e.target.closest('[data-vs-coupon-remove]');
      if (!removeBtn) return;
      e.preventDefault();
      removeCode(removeBtn.getAttribute('data-vs-coupon-remove'));
    });
  }

  /* ---- Init All ---- */
  function init() {
    initMobileMenu();
    initSearch();
    initCollectionSearch();
    initHeaderCategories();
    initCollectionResultFilter();
    initCartDrawer();
    initFAQ();
    initTestimonials();
    initStatsCounter();
    initProductGallery();
    initProductTabs();
    initQuickAdd();
    initProductRowControls();
    initStickyHeader();
    initAccountButtonFeedback();
    initRowImageLoading();
    initPdp();
    initPdpCustomSelects();
    initPdpVariants();
    initPdpBundle();
    initPdpJumpTabs();
    initCartActivationEmail();
    initCartPageAjax();
    initCartCoupon();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify editor events
  document.addEventListener('shopify:section:load', init);
})();
